"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.goal.efficiency': 'Wydajność',
    'slot.goal.accuracy': 'Dokładność',
    'slot.goal.creativity': 'Kreatywność',
    'slot.goal.detail': 'Szczegół',
};
